import { api, get, post, put, del } from './client.js';

const path = (hostId, suffix = '') =>
    `/api/ivr/admin/tenants/${encodeURIComponent(hostId)}/members${suffix}`;

export const membersApi = {
    list: (hostId) => get(path(hostId)),
    create: (hostId, body) => post(path(hostId), body),
    update: (hostId, uid, body) =>
        api('PATCH', path(hostId, `/${encodeURIComponent(uid)}`), { body }),
    remove: (hostId, uid) => del(path(hostId, `/${encodeURIComponent(uid)}`)),
    resetPassword: (hostId, uid) =>
        post(path(hostId, `/${encodeURIComponent(uid)}/reset-password`), {}),
};
